module.exports = {
    // basic
    'range': 'range',
    'mouths-previous': 'months previous',
    'include-tbd': 'Include TBD',
    // raw
    'select-at-least-one-entry-type': 'At least one entry type must be selected.',
    'must-select-spud-date': 'You must select spud date.',
    'must-select-spud-date-range': 'You must select start and end.',
    'must-enter-months-previous': 'You must enter months previous.',
    'must-select-spud-date-or-upload-date': 'You must select spud date filter or upload date filter.',
	// template
};
